import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store';

export default function ImpersonationBanner() {
  const { impersonating, stopImpersonating } = useAuthStore();
  const navigate = useNavigate();

  if (!impersonating) return null;

  const handleStop = () => {
    stopImpersonating();
    navigate('/app/admin/usuarios');
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
      background: '#b45309', color: '#fff',
      padding: '8px 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      fontSize: 13, fontWeight: 600,
    }}>
      <span>
        👁 Viendo como: <b>{impersonating.email}</b> · {impersonating.full_name}
      </span>
      <button onClick={handleStop} style={{
        background: 'rgba(255,255,255,.2)', border: 'none', color: '#fff',
        padding: '4px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 700,
      }}>
        ✕ Volver a admin
      </button>
    </div>
  );
}
